module.exports = __webpack_public_path__ + "static/media/SofiaProUltraLightItalic.6bd7b751.otf";